import { ApiResponse } from '@nohara-dxdev/oidc-core';
import { QueryConfig } from '@nohara-dxdev/react-core';
import { queryOptions, useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api-client';

import type { FlagTargetState } from '@nohara-dxdev/feature-flags';

export interface OrgFeatureFlagsResponse {
  flags: FlagTargetState[];
}

export const getOrgFeatureFlagsQueryKey = (orgId: string | null | undefined) =>
  ['feature-flags', 'admin', 'org', orgId ?? ''] as const;

export const getOrgFeatureFlags = async (orgId: string): Promise<OrgFeatureFlagsResponse> => {
  const { data } = await api.get<unknown, ApiResponse<OrgFeatureFlagsResponse>>(
    `/orgs/${orgId}/feature-flags`,
  );
  return data;
};

export const getOrgFeatureFlagsQueryOptions = (orgId: string | null | undefined) =>
  queryOptions({
    queryKey: getOrgFeatureFlagsQueryKey(orgId),
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    queryFn: () => getOrgFeatureFlags(orgId!),
    enabled: !!orgId,
  });

interface UseOrgFeatureFlagsOptions {
  orgId: string | null | undefined;
  queryConfig?: QueryConfig<typeof getOrgFeatureFlagsQueryOptions>;
}

export const useOrgFeatureFlags = ({ orgId, queryConfig = {} }: UseOrgFeatureFlagsOptions) =>
  useQuery({ ...getOrgFeatureFlagsQueryOptions(orgId), ...queryConfig });
